export const urls = {
  VRATI_PREGLED_SERVISA: 'DokRNServisni/dok_rn_servisni_pregled',
};
